import styled from 'styled-components';
import { breakpoints } from '../../theme';

export const CheckboxGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1rem;
`;

export const CheckboxWrapper = styled.label`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1rem;
  color: ${(props) => props.theme.text};

  input {
    width: 20px;
    height: 20px;
    cursor: pointer;
  }
`;

export const WhiteBackgroundWrapper = styled.div`
  background: rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(10px);
  border-radius: 15px;
  padding: 2rem;
  max-width: 80vw;
  margin: 2rem auto;
  @media (max-width: ${breakpoints.tablet}) {
    max-width: 100%;
    padding: 1rem;
  }
`;

export const ContentWrapper = styled.div`
  background: #ffffff;
  padding: 2rem;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  @media (max-width: ${breakpoints.tablet}) {
    padding: 1rem;
    margin: 0;
  }
`;

export const VolunteerSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  h1 {
    font-size: 2.5rem;
    margin-bottom: 1rem;
  }

  p {
    font-size: 1.2rem;
    margin-bottom: 1.5rem;
    display: flex;
    justify-content: center;
    text-align: center;
  }
`;

export const FormContainer = styled.div`
  width: 100%;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  label {
    font-size: 1.1rem;
    font-weight: bold;
  }

  input,
  textarea,
  select {
    font-size: 1rem;
    padding: 0.75rem;
    border-radius: 8px;
    border: 1px solid ${(props) => props.theme.border};
    background: ${(props) => props.theme.background};
    color: ${(props) => props.theme.text};

    &:focus {
      outline: 2px solid var(--color-highlight);
    }
  }

  button {
    align-self: center;
    padding: 0.75rem 2rem;
    font-size: 1rem;
    font-weight: bold;
    color: var(--color-button-text);
    background: var(--color-new-button-active);
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease;

    &:hover {
      background: var(--color-new-button-active-hover);
      transform: translateY(-2px);
      box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
    }

    &:focus {
      outline: 2px solid var(--color-highlight);
      outline-offset: 2px;
    }

    &:active {
      transform: translateY(0);
      box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
    }

    &:disabled {
      background: var(--color-disabled);
      color: #666;
      cursor: not-allowed;
    }
  }
`;

export const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: column;
  label {
    align-items: center;
  }
  input[type="checkbox"] {
    width: 20px;
    margin-right: 0.5rem;
  }
`;

export const VolunteerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem;
  width: 100%;
  box-sizing: border-box;
`;

export const Header = styled.div`
  text-align: center;
  margin-bottom: 2rem;
  h1 {
    margin: 0 0 0.5rem;
  }
  p {
    margin: 0;
  }
`;

/* The FormRow now uses a grid layout that switches to a single column on mobile */
export const FormRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  width: 100%;
  margin-bottom: 2rem;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  label {
    margin-bottom: 0.5rem;
    font-weight: 600;
  }
  input,
  textarea,
  select {
    width: 100%;
    padding: 0.75rem 1rem;
    margin-bottom: 1.25rem;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 1rem;
  }
`;

export const CommentsRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 2rem;
  label {
    font-weight: 600;
    margin-bottom: 0.5rem;
  }
  textarea {
    width: 50%;
    padding: 0.75rem 1rem;
    margin-bottom: 1.25rem;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 1rem;
    resize: vertical;
    @media (max-width: 768px) {
      width: 100%;
    }
  }
`;

export const ButtonRow = styled.div`
  margin-bottom: 2rem;
  text-align: center;
  button {
    padding: 0.75rem 1.5rem;
    font-size: 1rem;
    cursor: pointer;
    border: none;
    border-radius: 4px;
    background-color: #1976d2;
    color: #fff;
  }
  button:hover {
    background-color: #1565c0;
  }
`;

export const CounterCard = styled.div`
  text-align: center;
  background-color: #e3f2fd;
  border-radius: 8px;
  padding: 1rem;
  width: 100%;
  max-width: 600px;
`;

export const CounterTitle = styled.h2`
  color: #1976d2;
  margin-bottom: 0.5rem;
`;

export const CounterValue = styled.h1`
  color: #d32f2f;
  font-weight: bold;
  margin: 0;
`;

/* ================== New Styled Components for Success Modal ================== */

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background-color: #fff;
  border-radius: 8px;
  padding: 2rem;
  max-width: 500px;
  width: 90%;
  text-align: center;
`;

export const CloseButton = styled.button`
  margin-top: 1rem;
  padding: 0.5rem 1rem;
  background-color: #1976d2;
  border: none;
  border-radius: 4px;
  color: #fff;
  cursor: pointer;
`;
